import { type FC, useId } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { type ContactFormState } from '../../../contact-form'
import { useUserApiSwrSessionV1Customer } from '../../../user-data'

import { DirectContactFormNameInputFieldsSection } from './DirectContactFormNameInputFieldsSection'

interface Props {
  formState: ContactFormState
}

export const DirectContactFormEmailInputField: FC<Props> = ({ formState }) => {
  const intl = useIntl()
  formState.use()
  const { model } = formState

  const { data: userData } = useUserApiSwrSessionV1Customer()
  const isLoggedIn = Boolean(userData?.customerNumber)

  const emailId = useId()

  return isLoggedIn ? null : (
    <>
      <DirectContactFormNameInputFieldsSection formState={formState} />
      <FormControl
        className="mb-2"
        error={!model.validator.isPropertyValid('email')}
        onChange={(event): void => {
          formState
            .makeInputProps('email', { validateOnBlur: true })
            .onChange(event)
        }}
        required
        value={model.email}
      >
        <FormLabel htmlFor={emailId}>
          {intl.formatMessage({ id: 'general.label.email' })}
        </FormLabel>
        <Input
          id={emailId}
          slotProps={{
            input: {
              'data-qa-id': 'message-form-§emailForm.email',
            },
          }}
          type="email"
        />
        {model.validator.getFirstErrorFor('email') && (
          <FormHelperText data-qa-id="global-MessageForm-eMail-error-msg">
            {model.validator.getFirstErrorFor('email')}
          </FormHelperText>
        )}
      </FormControl>
    </>
  )
}
